import React from 'react'

import { useWindowSize } from '@hooks/useWindowSize'
import { WriterSalesAnalyticsDetailReportEnum } from '@interfaces/WriterSalesAnalyticsDetailReportEnum'
import NoData from '@components/NoData'
import { Tabs } from '@components/TabsV2'
import { TabModeEnum } from '@components/Tabs/interface'
import { EbookSalesAnalyticsDetailReportEnum } from '@interfaces/EbookSalesAnalyticsDetailReportEnum'
import { EbookOverviewTabsProps } from './interface'
import {
  columnsPreRead,
  columnsPromotion,
  columnsTotalSales,
  columnsSales,
  columnsView,
} from './columns'
import { SaleAnalyticsChart } from '../../../SaleAnalyticsOverview/components/SaleAnalyticsChart'
import { OverviewTableTemplate } from '../../../SaleAnalyticsOverview/components/OverviewTableTemplate'

export function EbookOverviewTabs({
  data,
  isLoading,
  sortParams,
  queryParams,
  handleTabChange,
  handleSortChange,
}: EbookOverviewTabsProps) {
  const { isMobile, isTablet } = useWindowSize()
  const isNoData =
    data.graphData.length === 0 && data.tableData.length === 0 && !isLoading
  return (
    <div className='mt-[60px]'>
      <Tabs
        tabs={[
          {
            key: EbookSalesAnalyticsDetailReportEnum.SALES,
            title: 'ยอดขาย',
            component: (
              <>
                {isNoData ? (
                  <NoData />
                ) : (
                  <>
                    <SaleAnalyticsChart
                      data={data.graphData}
                      graphType={data.graphType}
                      tabId={
                        WriterSalesAnalyticsDetailReportEnum.SALES_BY_CHAPTER
                      }
                      style={{
                        height: isMobile ? 260 : 300,
                        width: isMobile ? 340 : isTablet ? 750 : 1166,
                      }}
                    />
                    <OverviewTableTemplate
                      title='ยอดขาย'
                      data={data.tableData}
                      columns={columnsSales({
                        sortParams,
                        isMobile,
                        handleSortChange,
                      })}
                    />
                  </>
                )}
              </>
            ),
          },
          {
            key: EbookSalesAnalyticsDetailReportEnum.PURCHASE_COUNT,
            title: 'จำนวนที่ขาย',
            component: (
              <>
                {isNoData ? (
                  <NoData />
                ) : (
                  <>
                    <SaleAnalyticsChart
                      data={data.graphData}
                      graphType={data.graphType}
                      style={{
                        height: isMobile ? 260 : 300,
                        width: isMobile ? 340 : isTablet ? 750 : 1166,
                      }}
                    />
                    <OverviewTableTemplate
                      title='จำนวนที่ขาย'
                      data={data.tableData}
                      columns={columnsTotalSales({
                        sortParams,
                        isMobile,
                        handleSortChange,
                      })}
                    />
                  </>
                )}
              </>
            ),
          },
          {
            key: EbookSalesAnalyticsDetailReportEnum.PROMOTION,
            title: 'โปรโมชั่น',
            component: (
              <>
                {isNoData ? (
                  <NoData />
                ) : (
                  <>
                    <SaleAnalyticsChart
                      data={data.graphData}
                      graphType={data.graphType}
                      style={{
                        height: isMobile ? 260 : 300,
                        width: isMobile ? 340 : isTablet ? 750 : 1166,
                      }}
                    />
                    <OverviewTableTemplate
                      title='โปรโมชั่น'
                      data={data.tableData}
                      columns={columnsPromotion({
                        sortParams,
                        handleSortChange,
                      })}
                    />
                  </>
                )}
              </>
            ),
          },
          {
            key: EbookSalesAnalyticsDetailReportEnum.VIEW,
            title: 'ยอดวิว',
            component: (
              <>
                {isNoData ? (
                  <NoData />
                ) : (
                  <>
                    <SaleAnalyticsChart
                      data={data.graphData}
                      graphType={data.graphType}
                      style={{
                        height: isMobile ? 260 : 300,
                        width: isMobile ? 340 : isTablet ? 750 : 1166,
                      }}
                    />
                    <OverviewTableTemplate
                      title='ยอดวิว'
                      data={data.tableData}
                      columns={columnsView({
                        sortParams,
                        isMobile,
                        handleSortChange,
                      })}
                    />
                  </>
                )}
              </>
            ),
          },
          {
            key: EbookSalesAnalyticsDetailReportEnum.READ_TRIAL_CHAPTERS,
            title: 'ทดลองอ่าน',
            component: (
              <>
                {isNoData ? (
                  <NoData />
                ) : (
                  <>
                    <SaleAnalyticsChart
                      data={data.graphData}
                      graphType={data.graphType}
                      style={{
                        height: isMobile ? 260 : 300,
                        width: isMobile ? 340 : isTablet ? 750 : 1166,
                      }}
                    />
                    <OverviewTableTemplate
                      title='ทดลองอ่าน'
                      data={data.tableData}
                      columns={columnsPreRead({
                        sortParams,
                        isMobile,
                        handleSortChange,
                      })}
                    />
                  </>
                )}
              </>
            ),
          },
        ]}
        initialTab={EbookSalesAnalyticsDetailReportEnum.SALES}
        mode={TabModeEnum.LINE}
        handleTabChange={handleTabChange}
        isLoading={isLoading}
        queryTabKey='ebookReportType'
      />
    </div>
  )
}
